import type { AgentSession } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface StopSessionDialogProps {
  session: AgentSession | null;
  isStopping: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function StopSessionDialog({
  session,
  isStopping,
  onCancel,
  onConfirm,
}: StopSessionDialogProps) {
  return (
    <Modal open={session !== null} title="Stop session" onClose={onCancel}>
      <p>
        Stop <strong>{session?.label}</strong>? The agent container will be shut down. You can delete
        the session record afterwards.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isStopping}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isStopping}>
          {isStopping ? "Stopping…" : "Stop"}
        </Button>
      </div>
    </Modal>
  );
}
